<template>

    <m-edit1/>

    <m-stores-1 v-bind='{...{},...{}}' :style='""' class="" ></m-stores-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mStores1 from '@moeinmdn/miw-alpha-components/src/package/MultipleStore/Archive/Stores1';

export default {
    name: 'HomeView',
    components: {mEdit1, mStores1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
